// in newer verison of moment the check becomes moment.isMoment(dataForKey)


var apiFormat = function(data) {
    var formmatedObj = {};
    if (data){
        Object.keys(data).forEach(key => {
            var dataForKey = data[key];

            var isMomentObj = dataForKey && dataForKey._isAMomentObject;
            if(isMomentObj) {
                formmatedObj[key] = dataForKey.toISOString();
                return;
            }

            if(Array.isArray(dataForKey)) {
                formmatedObj[key] = dataForKey.map(d => d._isAMomentObject ? d.toISOString() : d);
                return;
            }

            if(typeof dataForKey == 'object' && dataForKey != null) {
                formmatedObj[key] = apiFormat(dataForKey);
                return;
            }

            formmatedObj[key] = dataForKey;
        });
    }    

    return formmatedObj;
};

export default apiFormat;


// WEBPACK FOOTER //
// ./app/utils/apiFormat.js